<template>
  <div>
    <input
      type="password"
      class="form-control form-control-sm"
      :id="'dynamicID-' + (Math.floor(Math.random() * Date.now()).toString())"
      v-model="newValue"
      @change="changeValue()"
      @click="clearInput()"
      autocomplete="nope"
    />
  </div>
</template>

<script>

export default {
  name: 'textInputField',
  created: async function () {
    this.newValue = this.passedData.value;
  },
  data: function () {
    return {
      newValue: this.passedData.value,
    }
  },
  methods: {
    changeValue: function() {
      if (this.passedData.value !== this.newValue) {
        let returnData = {
          name: this.passedData.name,
          index: this.passedData.index,
          newValue: this.newValue,
          value: this.passedData.value
        };

        this.$emit("input", returnData);
      }
    },
    clearInput: function () {
      this.newValue = "";

      let returnData = {
        name: this.passedData.name,
        index: this.passedData.index,
        newValue: null,
        value: null
      };

      this.$emit("input", returnData);
    },
  },
  props: ['passedData'],
}

</script>
